<template>
  <div class="base">
    <inside-header color="#fff" title="我的孩子" back-link-name="UserIndex" />
    <div class="main">
      <div class="list">
        <div v-for="(item, index) in list" :key="index" class="item"
          :style="{ backgroundColor: index % 2 === 0 ? '#ffeee5' : '#e5f1ff' }">
          <a-row class="area">
            <a-col :span="6" class="header">
              <img src="@/assets/test-header.png" alt="" @click="gotoAddChild(item.id)">
            </a-col>
            <a-col :span="10" class="student-info">
              <div class="name" @click="gotoAddChild(item.id)">
                {{ item.nick_name }}
              </div>
              <div class="grade">
                {{ item.stage }}
              </div>
            </a-col>
            <a-col :span="8" class="examine">
              <a-button style="color: #666" :ghost="true" @click="showStudentCourse(item.id)">
                查看课程
              </a-button>
            </a-col>
          </a-row>
        </div>
      </div>
      <div style="margin: 16px;" class="add-child">
        <button @click="gotoAddChild(0)">
          <span class="add-icon">
            <van-icon name="plus" />
          </span>
          <span class="btn-title">添加一个孩子</span>
        </button>
      </div>
    </div>
    <main-footer />
  </div>
</template>
<script>
import { MainFooter, InsideHeader } from '@/components'
export default {
  name: 'UserStudents',
  components: {
    MainFooter,
    InsideHeader
  },
  data() {
    return {
      list: []
    }
  },
  created() {
    // this.loadData(this.id, this.$route.query)
    this.loadData()
  },
  methods: {
    loadData() {
      this.$http({
        url: 'index/user/studentList',
        method: 'get'
      }).then(res => {
        console.log(res)
        if (res.status === 'success') {
          var data = res.data
          this.list = data.list
        }
      })
    },
    showStudentCourse(studentId) {
      this.$router.push({ name: 'UserCourseArrangement', query: { student_id: studentId } })
    },
    gotoAddChild(id) {
      if (id) {
        this.$router.push({ name: 'UserAddChild', params: { id: id } })
      } else {
        this.$router.push({ name: 'UserAddChild' })
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
  .base {
    min-width: 280px;
    max-width: 420px;
    margin: auto;
    background-color: #fff;
  }

  .main {
    padding: 15px;

    .list {

      .item {
        padding: 15px;
        background-color: #ffeee5;
        border-radius: 10px;
        margin-bottom: 10px;

        .header {
          img {
            width: 60px;
            height: 60px;
            background-color: #f3f3f3;
            border-radius: 50%;
          }
        }

        .student-info {

          .name {
            font-family: PingFang-SC-Bold;
            font-size: 16px;
            line-height: 21px;
            color: #333333;
            font-weight: bold;
          }

          .grade {
            font-family: PingFang-SC-Medium;
            font-size: 14px;
            line-height: 28px;
            color: #666666;
          }

        }

        .examine {
          line-height: 60px;
          button {
            border-radius: 17px;
            border: solid 1px #999999;
          }
        }
      }
    }

    .add-child {
      color: $theme-color;

      button {
        width: 100%;
        height: 40px;
        background-color: #ffffff;
        border-radius: 20px;
        border: solid 1px #ffe8db;
      }

      .add-icon {
        position: relative;
        top: 2px;
      }

      .btn-title {
        margin-left: 4px;
      }
    }
  }
</style>
